import { render, staticRenderFns } from "./endorsement.vue?vue&type=template&id=8a91a42a&"
import script from "./endorsement.vue?vue&type=script&lang=js&"
export * from "./endorsement.vue?vue&type=script&lang=js&"
import style0 from "./endorsement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports